import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/mockyeah-docs/src/layouts/default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "cli",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#cli",
        "aria-label": "cli permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`CLI`}</h1>
    <p><code parentName="p" {...{
        "className": "language-text"
      }}>{`@mockyeah/cli`}</code>{` provides a simple command-line interface for recording and playing suites to integrate with during development.`}</p>
    <h2 {...{
      "id": "getting-started",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#getting-started",
        "aria-label": "getting started permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Getting started`}</h2>
    <ol>
      <li parentName="ol">{`Install `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`@mockyeah/cli`}</code></li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "shell"
    }}><pre parentName="div" {...{
        "className": "language-shell"
      }}><code parentName="pre" {...{
          "className": "language-shell"
        }}>{`$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{` -g @mockyeah/cli`}</code></pre></div>
    <p>{`or`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "shell"
    }}><pre parentName="div" {...{
        "className": "language-shell"
      }}><code parentName="pre" {...{
          "className": "language-shell"
        }}>{`$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`yarn`}</span>{` global `}<span parentName="code" {...{
            "className": "token function"
          }}>{`add`}</span>{` @mockyeah/cli`}</code></pre></div>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Configure a service call to proxy through mockyeah`}</li>
    </ol>
    <p>{`To do so prepend `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`http://localhost:4001/`}</code>{` to the beginning of a service end-point in your project like so:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`http://localhost:4001/http://example.com/your/service/url`}</code></pre></div>
    <p>{`We agree the above URL looks pretty nutty, but rest assured all other known approaches add unnecessary complexity.`}</p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">
        <p parentName="li">{`Initiate a `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`mockyeah`}</code>{` suite recording`}</p>
        <div parentName="li" {...{
          "className": "gatsby-highlight",
          "data-language": "shell"
        }}><pre parentName="div" {...{
            "className": "language-shell"
          }}><code parentName="pre" {...{
              "className": "language-shell"
            }}>{`$ mockyeah record my-first-suite`}</code></pre></div>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Invoke the service call you previously configured. You should see @mockyeah/cli output.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Stop @mockyeah/cli by hitting enter on the stop question.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Play back the suite`}</p>
        <div parentName="li" {...{
          "className": "gatsby-highlight",
          "data-language": "shell"
        }}><pre parentName="div" {...{
            "className": "language-shell"
          }}><code parentName="pre" {...{
              "className": "language-shell"
            }}>{`$ mockyeah play my-first-suite`}</code></pre></div>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Invoke the service call again.`}</p>
      </li>
    </ol>
    <p>{`Good work! You've recorded and played back a suite.`}</p>
    <h2 {...{
      "id": "options",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#options",
        "aria-label": "options permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Options`}</h2>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "shell"
    }}><pre parentName="div" {...{
        "className": "language-shell"
      }}><code parentName="pre" {...{
          "className": "language-shell"
        }}>{`$ mockyeah --help

Usage: mockyeah `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`options`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`command`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`

  Commands:

    list                list suites
    play `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`suiteNames`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`   play suite`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`s`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    playAll             play all suites
    record `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`suiteName`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`  record suite
    start               start server
    `}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`help`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`cmd`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`          display `}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`help`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`cmd`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`

  Options:

    -h, --help     output usage information
    -V, --version  output the version number`}</code></pre></div>
    <p>{`For help with specific commands, you can pass `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`--help`}</code>{` to them, e.g.:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "shell"
    }}><pre parentName="div" {...{
        "className": "language-shell"
      }}><code parentName="pre" {...{
          "className": "language-shell"
        }}>{`$ mockyeah record --help

Usage: mockyeah-record `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`options`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`

Options:
  -g, --groups `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`names`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`      record with these named `}<span parentName="code" {...{
            "className": "token function"
          }}>{`groups`}</span>{` from configuration `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`comma-separated and/or repeatable`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  --group `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`names`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`           `}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`alias`}</span>{` of -g, --groups
  -o, --only `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`string`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`       only record calls to URLs containing given string `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`repeatable`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  -r, --only-regex `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`regex`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`  only record calls to URLs matching given regex pattern `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`repeatable`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  -h, --use-headers         record headers to response options
  -l, --use-latency         record latency to response options
  -H, --header `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`pair`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`       record matches will require these headers `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"Name: Value"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`repeatable`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  -v, --verbose             verbose output
  -h, --help                output usage information`}</code></pre></div>
    <h2 {...{
      "id": "play",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#play",
        "aria-label": "play permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Play`}</h2>
    <p><code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah play [options] [suiteNames]`}</code></p>
    <p>{`Play one or more suites, passing comma-separated list of suite names, or else be prompted to pick one.`}</p>
    <p>{`E.g., comma-separated:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "shell"
    }}><pre parentName="div" {...{
        "className": "language-shell"
      }}><code parentName="pre" {...{
          "className": "language-shell"
        }}>{`$ mockyeah play some-custom-suite,some-custom-suite-2`}</code></pre></div>
    <p>{`or space-separated:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "shell"
    }}><pre parentName="div" {...{
        "className": "language-shell"
      }}><code parentName="pre" {...{
          "className": "language-shell"
        }}>{`$ mockyeah play some-custom-suite some-custom-suite-2`}</code></pre></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      